document.addEventListener("DOMContentLoaded", function () {
    const ctas = document.querySelectorAll(".multi-cta-button");

    ctas.forEach(function (btn) {
      btn.addEventListener("click", function (event) {
        event.preventDefault();

        const filterUrl = btn.getAttribute("href");
        if (!filterUrl) return;

        // If URL does not contain Fast Simon filters, just redirect
        if (!filterUrl.includes("filters=")) {
          window.location.href = filterUrl;
          return;
        }

        // Parse "?filters=params"
        const filterString = filterUrl.split("filters=")[1] || "";
        const colonCount = (filterString.match(/:/g) || []).length;

        // Multiple filters -> use normal redirect
        if (colonCount > 1) {
          window.location.href = filterUrl;
          return;
        }

        const [rawTermPart, rawValuePart] = filterString.split(":");
        const termRaw = (rawTermPart || "").split(",")[0];
        const valueRaw = rawValuePart || "";

        const valueDecoded = decodeURIComponent(valueRaw.replace(/\+/g, " "));
        const facetLabel =
          termRaw.charAt(0) + termRaw.slice(1).toLowerCase();
        const narrowExpr = facetLabel + ":" + valueDecoded;

        function applyFastSimonFilter() {
          // If FS is not ready, fallback to redirect
          if (
            !window.SerpOptions ||
            typeof window.SerpOptions.registerHook !== "function"
          ) {
            window.location.href = filterUrl;
            return;
          }

          // 1) Register Fast Simon hook
          window.SerpOptions.registerHook("serp-fixed-narrow", function () {
            return { term: [narrowExpr] };
          });

          // 2) Trigger FS hooks
          if (typeof window.hooks === "function") {
            window.hooks();
          }

          // 3) Dispatch CustomEvent with same shape as old banner
          const narrow = {};
          narrow[termRaw || "WIDTH"] = new Set([narrowExpr]);

          document.dispatchEvent(
            new CustomEvent("send-fast-simon-params", {
              detail: { narrow: narrow },
            })
          );

          // 4) Update URL without full reload
          window.history.pushState({}, "", filterUrl);

          // 5) Scroll to product grid
          const anchor = document.getElementById("fast-simon-serp-app");
          if (anchor) {
            anchor.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        }

        // If FS is already loaded, apply immediately
        if (window.SerpOptions && typeof window.hooks === "function") {
          applyFastSimonFilter();
        } else {
          // Otherwise, wait until FS triggers its ready event
          window.addEventListener("fast-serp-ready", function handler() {
            window.removeEventListener("fast-serp-ready", handler);
            applyFastSimonFilter();
          });
        }
      });
    });
});